import * as types from '../constants/ActionTypes';

const initialState = {
  items: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.SELECT_TOPIC_L1:
      return Object.assign({}, state, { items: [action.payload.topic_name] });
    case types.SELECT_TOPIC_L2:
      return Object.assign({}, state, { items: [state.items[0], action.payload.topic_name] });
    case types.SELECT_TOPIC_L3:
      return Object.assign({}, state, { items: [...state.items.slice(0, 2), action.payload.topicName] });
    default:
      return state;
  }
}
